import { createContext, useContext } from 'react';

// How a write made through ANOTHER endpoint reaches a member's row in
// memberRecords without the pedigree autosave sending the old row first.
//
// PedigreeChart's autosave $sets every non-proband member's WHOLE row from
// memberRecords (see autosaveController.js). A section that writes a person's
// data through its own endpoint therefore has to put the server's answer on the
// row as well, or the next unrelated save in the family writes the old value
// back over it. Where the client can build the new value itself (a person tag)
// it updates the row before the request and needs nothing from here. Where the
// server reshapes what was sent (variants pushed from a Test record are
// deduped and ClinVar-enriched), the row can only be patched after reading it
// back, and something has to stop a save going out in between. That is what
// this provides:
//
//   getMemberRecords()          the records as they are now (a ref read)
//   setMemberRecords(updater)   the chart's own setter. Call it bare: moving the
//                               save status to IN_PROGRESS would send a
//                               redundant POST and take the family lock for it.
//   runWithAutosaveHeld(task, { reason })
//                               runs `task` with the autosave held: a save in
//                               flight settles first, none starts until `task`
//                               has finished, and a save that was pending is
//                               sent afterwards from the patched rows.
//
// Provided by PedigreeChart around ChartBox, so it reaches the sidebar, the
// person region and the bulk editor alike. Null outside a chart (component
// tests, any other host): callers then keep their previous behaviour.
export const MemberRowSyncContext = createContext(null);

export const useMemberRowSync = () => useContext(MemberRowSyncContext);
